import { YearOfEducEnum } from "@/utils/enums";

const DEFAULT_YEAR_OF_EDUCATION = [{ name: "Not Applicable" }, ...YearOfEducEnum];

const getFirstPresentValue = (...values) =>
  values.find((value) => value !== "" && value != null);

const toFiniteNumber = (value) => {
  if (value === "" || value == null) {
    return null;
  }

  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : null;
};

export const getYearOfEducationOrder = (
  yearOfEducation,
  yearOptions = DEFAULT_YEAR_OF_EDUCATION,
) => {
  const normalizedYear = yearOfEducation?.toString().trim();
  if (normalizedYear === "Not Applicable") {
    return 0;
  }

  const yearMatch = normalizedYear?.match(
    /^(\d+)(?:st|nd|rd|th)?\s+year(?:\s+(\d+)(?:st|nd|rd|th)?\s+semester)?$/i,
  );
  if (yearMatch) {
    const yearNumber = Number(yearMatch[1]);
    const semesterNumber = yearMatch[2] ? Number(yearMatch[2]) : 0;
    return yearNumber * 10 + semesterNumber;
  }

  const index = yearOptions.findIndex((item) => item?.name === yearOfEducation);
  return index === -1 ? Number.MAX_SAFE_INTEGER : 1000 + index;
};

export const normalizeStudentStatusGpaItems = (
  items = [],
  yearOptions = DEFAULT_YEAR_OF_EDUCATION,
) => {
  void yearOptions;
  return items.map((item) => ({
    ...item,
    yearOfEducation: getFirstPresentValue(
      item?.yearOfEducation,
      item?.year_of_education,
    ),
    studentStatus: getFirstPresentValue(
      item?.studentStatus,
      item?.student_status,
    ),
    gpa: toFiniteNumber(
      getFirstPresentValue(
        item?.gpa,
        item?.GPA,
        item?.semesterGpa,
        item?.semester_gpa,
      ),
    ),
    cumulativeGpa: toFiniteNumber(
      getFirstPresentValue(
        item?.cumulativeGpa,
        item?.cumulativeGPA,
        item?.cumulative_gpa,
        item?.cgpa,
        item?.CGPA,
      ),
    ),
  }));
};

export const getStudentStatusGpaItems = (
  record = {},
  yearOptions = DEFAULT_YEAR_OF_EDUCATION,
) => {
  const collections = [
    record?.pre_student_statuses,
    record?.preStudentStatuses,
    record?.generic_student_statuses,
    record?.genericStudentStatuses,
    record?.studentStatuses,
  ].filter(Array.isArray);
  const items = collections.reduce(
    (longestCollection, collection) =>
      collection.length > longestCollection.length
        ? collection
        : longestCollection,
    [],
  );

  return normalizeStudentStatusGpaItems(items, yearOptions)
    .map((item, index) => ({ index, item }))
    .sort((left, right) => {
      const yearOrderDifference =
        getYearOfEducationOrder(left.item?.yearOfEducation, yearOptions) -
        getYearOfEducationOrder(right.item?.yearOfEducation, yearOptions);

      return yearOrderDifference || left.index - right.index;
    })
    .map(({ item }) => item);
};
